import apiClient from './apiClient';

const taskClient = apiClient("");

const taskApi = {
    // Получить все задачи (GET)
    async getAllTasks() {
        try {
            const response = await taskClient.get('/tasks');
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении всех задач:', error);
            throw error;
        }
    },

    // Получить задачу по ID (GET) s
    async getTaskById(id) {
        try {
            const response = await taskClient.get(`/tasks/promo/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении задачи с ID ${id}:`, error);
            throw error;
        }
    },

    // Создать новую задачу (POST)
    async createTask(taskData) {
        try {
            const response = await taskClient.post('/tasks/promo', taskData);
            return response.data;
        } catch (error) {
            console.error('Ошибка при создании задачи:', error);
            throw error;
        }
    },
    /**
     * Пользователь выполняет задачу (отмечает как completed)
     * POST /tasks/complete
     * @param {{ userId: number; promoId: number; taskId: number }} params
     */
    async completeTask({ userId, promoId, taskId }) {
        try {
            const { data } = await taskClient.post('/tasks/complete', {
                user_id: userId,
                promo_id: promoId,
                task_id: taskId,
            });
            return data;
        } catch (error) {
            console.error('Ошибка при выполнении задачи:', error);
            throw error;
        }
    },
    /**
     * Получить прогресс пользователя по задачам промо
     * GET /tasks/promo/:promoId/user/:userId
     */
    async getUserProgress(promoId, userId) {
        try {
            const { data } = await taskClient.get(
                `/tasks/promo/${promoId}/user/${userId}`
            );
            return data;
        } catch (error) {
            console.error(
                `Ошибка при получении прогресса пользователя ${userId} для промо ${promoId}:`,
                error
            );
            throw error;
        }
    },


    // Создать задачу по ID (POST)
    async createTaskById(id, taskData) {
        try {
            const response = await taskClient.post(`/tasks/promo/${id}`, taskData);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при создании задачи с ID ${id}:`, error);
            throw error;
        }
    }
};

export default taskApi;
